import React from 'react';

// importing MyRouts where we located all of our theme
import MyRouts from './routers/routes';
import store from './store/index'
import { Provider } from 'react-redux'

function App() {
  return (
    <Provider store={store}>
      <MyRouts />
    </Provider>
  );
}

export default App;
